var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_15290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.5 12.189C34.5 17.988 29.799 22.689 24 22.689C18.201 22.689 13.5 17.988 13.5 12.189C13.5 6.38997 18.201 1.68896 24 1.68896C29.799 1.68896 34.5 6.38997 34.5 12.189Z",
    fill: "black",
    stroke: "#161614",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 31.689C37.4314 31.689 38.7911 31.9974 40.0433 32.5382L26.0999 58.689H1.5V42.189C1.5 36.3904 6.20143 31.689 12 31.689H36Z",
    fill: "black",
    stroke: "#161614",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0588 29.1743C48.6071 28.3272 47.3929 28.3272 46.9412 29.1743L24.9412 70.4243C24.5149 71.2236 25.0941 72.189 26 72.189H70C70.9059 72.189 71.4851 71.2236 71.0588 70.4243L49.0588 29.1743ZM48 69.189C46.341 69.189 45 67.848 45 66.189C45 64.53 46.341 63.189 48 63.189C49.659 63.189 51 64.53 51 66.189C51 67.848 49.659 69.189 48 69.189ZM48 60.189C46.341 60.189 45 58.848 45 57.189V42.189C45 40.53 46.341 39.189 48 39.189C49.659 39.189 51 40.53 51 42.189V57.189C51 58.848 49.659 60.189 48 60.189Z",
    fill: "#F30002"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_15290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white",
    transform: "translate(0 0.188965)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.cdb9c770ec63f2c8c1cac38c3a749819.svg";
export { ForwardRef as ReactComponent };